import { render, staticRenderFns } from "./QuestionRadio.vue?vue&type=template&id=fc688af2&scoped=true"
import script from "./QuestionRadio.vue?vue&type=script&lang=js"
export * from "./QuestionRadio.vue?vue&type=script&lang=js"
import style0 from "./QuestionRadio.vue?vue&type=style&index=0&id=fc688af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc688af2",
  null
  
)

export default component.exports